import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getCookie, removeCookie, setCookie } from "typescript-cookie";
import { UserSession } from "../../types/usuarios/UserSession";
import { expirationTokenAuth } from "../../utils/jwtUtils";
import { GetVoidLoggedUser } from "../../types/usuarios/LoggedUser";
import { useAppSelector } from "../hooks";
import { useSelector } from "react-redux";
import { RootState } from "../store";

const tokenFromCookie = getCookie('tokenAyudantia');
const userDataFromCookie = getCookie('userData');
const expiration = getCookie('expirationTime');


const isExpired = tokenFromCookie ? expirationTokenAuth(tokenFromCookie) : true;

const initialState: UserSession = {
    isAuth: tokenFromCookie !== undefined && !expirationTokenAuth(tokenFromCookie),
    token: tokenFromCookie || '',
    userData: tokenFromCookie && userDataFromCookie
        ? JSON.parse(userDataFromCookie)
        : GetVoidLoggedUser(),
    isLoading: false,
    expiration : isExpired,
    expirationTime: expiration ? parseInt(expiration) : 0
};



export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        inUser: (state, action: PayloadAction<UserSession>) => {
            const { token, userData } = action.payload;
            
            if (token) {
                //eliminar cookies en caso de que existan
                removeCookie('tokenAyudantia');
                removeCookie('userData');
                removeCookie('expirationTime');
                
                state.isAuth = true;
                state.token = token;
                state.userData = userData;
                state.isLoading = false;
                state.expiration = false; // Al iniciar sesión, el token no está expirado
                state.expirationTime = Date.now() + 2 * 60 * 60 * 1000; // Guardamos el tiempo exacto
                // Guardar en cookies
                setCookie('tokenAyudantia', token, { expires: 7 }); // Expira en 7 días
                setCookie('userData', JSON.stringify(userData), { expires: 7 });
                setCookie('expirationTime', state.expirationTime.toString(), { expires: 7 });
            }
            
        },
        outUser: (state) => {
            state.isAuth = false;
            state.token = '';
            state.userData = GetVoidLoggedUser();
            state.expiration = true; // Cuando cierra sesión, el token está expirado
            state.expirationTime = 0;
            localStorage.clear();
            sessionStorage.clear();

            // Eliminar las cookies
            removeCookie('tokenAyudantia');
            removeCookie('userData');
            removeCookie('expirationTime');
        },
    }
})

export const{ inUser, outUser } = authSlice.actions;

